import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    DELETE_DOCUMENT: createActionType(FULL_NAMESPACE, "DELETE_DOCUMENT"),
    DELETE_DOCUMENT_COMPLETED: createActionType(FULL_NAMESPACE, "DELETE_DOCUMENT_COMPLETED")
};
